import { useContext, useMemo } from 'react'
import { ReportPeriodContext } from '../../../context/report-periods/report-periods'
import { INotesPanelPeriodOption } from './notes-panel'

/**
 * The reporting periods a location, supplier or vehicle note can be disclosed in: every period of
 * the organisation, newest first. Locked periods are included because a note never changes a
 * figure.
 */
export const useNotePeriodOptions = (): INotesPanelPeriodOption[] => {
  const reportPeriodContext = useContext(ReportPeriodContext)
  return useMemo(
    () => [...(reportPeriodContext.allReportPeriods ?? [])]
      .sort((a, b) => String(b.calendarYear ?? '').localeCompare(String(a.calendarYear ?? '')))
      .map((period) => ({ id: period.id, label: period.friendlyName || period.calendarYear })),
    [reportPeriodContext.allReportPeriods],
  )
}
